import React, { useEffect, useState } from 'react';
import _ from 'lodash';

import ActionButton from '../../Common/ActionButton';
import PanelBlock from '../../Common/PanelBlock';
import Field from '../../Fields/Field';
import LineItemEntry, { manualAdjustmentLineItemEntryTypes } from '../../../Entities/LineItemEntry';
import getTotalAmount from '../../../Utils/invoicePanel'
import InputSelectField from '../../Fields/InputSelectField';
import InvoiceTotalSummaryTable from './InvoiceTotalSummaryTable';

const InvoiceAdjustmentPanel = ({
  lineItemTableRows,
  invoiceLineItemsSaveInProgress,
  handleAdjustInvoiceSaveClick,
  handleAdjustInvoiceCancelClick,
  onAdjustmentActionChange,
  adjustmentActionTypes,
  balance,
  currentBalance,
  adjustmentTypes,
  onLineItemChange,
  lineItems,
}) => {
  const [adjustmentActionType, setAdjustmentActionType] = useState('');
  const [adjustmentType, setAdjustmentType] = useState('');

  const types = adjustmentTypes.filter((action) =>
    manualAdjustmentLineItemEntryTypes.includes(action.value)
  );

  useEffect(() => {
    if(adjustmentType) {
      onAdjustmentTypeChange(adjustmentType)
    }
  }, [adjustmentType])
  
  const handleActionChange = (value) => {
    onLineItemChange(lineItems);
    setAdjustmentType('');
    setAdjustmentActionType(value);
    if (value === 'CUSTOM') {
      onAdjustmentActionChange(true);
    } else {
      onAdjustmentActionChange(false);
    }
  };

  const onAdjustmentTypeChange = (value) => {
    if(value) {
      const lineItems = []
      const amounts = {amount: null, amount_tax_1: null, amount_tax_2: null, amount_tax_3: null, amount_tax_4: null, gross_amount: null};
      for (let i = 0; i < lineItemTableRows.length; i++) {
        const lineItem = _.cloneDeep(lineItemTableRows[i].data);
        const newEntryExists = lineItem.fields.entries.value.find(entry => entry.fields.created_at.value === null)
        const adjustedGrossAmounts = adjustmentActionType === 'PARTIAL' ? amounts : getTotalAmount([lineItemTableRows[i]], balance, true);
        const lineItemEntry = new LineItemEntry();
        lineItemEntry.fields.type.value = adjustmentType;
        lineItemEntry.fields.amount.value = adjustedGrossAmounts.amount;
        lineItemEntry.fields.amount_tax_1.value = adjustedGrossAmounts.amount_tax_1;
        lineItemEntry.fields.amount_tax_2.value = adjustedGrossAmounts.amount_tax_2;
        lineItemEntry.fields.amount_tax_3.value = adjustedGrossAmounts.amount_tax_3;
        lineItemEntry.fields.amount_tax_4.value = adjustedGrossAmounts.amount_tax_4;
        if(lineItem.fields.balance.value > 0 && (adjustmentActionType === 'PARTIAL' ? !newEntryExists : true)) {
          lineItem.fields.entries.value.push(lineItemEntry)
        };
        lineItems.push(lineItem)
      }
      onLineItemChange(lineItems)
    }
  }

  return (
    <div className='parkchirp--invoice-payment-panel'>
      <PanelBlock
        heading={'Adjust Invoice'}
        actions={[
          <ActionButton
            label={'Save'}
            inProgressState={invoiceLineItemsSaveInProgress}
            onClick={handleAdjustInvoiceSaveClick}
            disabled={
              adjustmentActionType === 'CUSTOM'
                ? false
                : !adjustmentActionType || !adjustmentType
            }
          />,
          <button
            type='button'
            className='parkchirp--button-as-link'
            style={{ paddingLeft: '10px', paddingRight: '10px' }}
            onClick={handleAdjustInvoiceCancelClick}
            disabled={invoiceLineItemsSaveInProgress}
          >
            Cancel
          </button>,
        ]}
      >
        <div
          className='parkchirp--invoice-adjustment-panel'
          style={{ display: 'flex' }}
        >
          <div className='parkchirp--invoice-payment-panel--main-inputs-container'>
            <Field
              label='Adjustment Action'
              id='parkchirp--payment--type'
              containerClasses={['parkchirp--payment-input-block']}
              layout='stacked'
            >
              <InputSelectField
                inputId='parkchirp--payment--type'
                options={[{ label: '', value: null }, ...adjustmentActionTypes]}
                value={adjustmentActionType}
                onChange={(value) => handleActionChange(value)}
                editMode={true}
              />
            </Field>
          </div>
          {adjustmentActionType && adjustmentActionType !== 'CUSTOM' && (
            <div
              className='parkchirp--invoice-payment-panel--main-inputs-container'
              style={{ width: '15%', marginLeft: '2rem' }}
            >
              <Field
                label='Adjustment Type'
                id='parkchirp--payment--type'
                containerClasses={['parkchirp--payment-input-block']}
                layout='stacked'
              >
                <InputSelectField
                  inputId='parkchirp--payment--type'
                  options={[{ label: '', value: null }, ...types]}
                  value={adjustmentType}
                  onChange={(value) => {
                    adjustmentActionType !== 'PARTIAL' && onLineItemChange(lineItems);
                    setAdjustmentType(value)
                  }}
                  editMode={true}
                />
              </Field>
            </div>
          )}
          <div style={{ width: '77%', marginLeft: '2rem' }}>
            {adjustmentActionType && (
              <InvoiceTotalSummaryTable
                lineItemTableRows={lineItemTableRows}
                balance={balance}
                currentBalance={currentBalance}
                adjustmentType={adjustmentType}
                onLineItemChange={onLineItemChange}
                editMode={adjustmentActionType === 'PARTIAL' && adjustmentType}
              />
            )}
          </div>
        </div>
      </PanelBlock>
    </div>
  );
};

export default InvoiceAdjustmentPanel;
